














import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs.vue';
import useStructuredData, { Breadcrumbs as BreadcrumbsInterface } from '~/composables/useStructuredData';
import { PAGE_SUFFIX } from '~/constants';
import { htmlDecode } from '~/helpers/htmlDecoder';
import { Breadcrumb } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'CategoryBreadcrumbs',
  components: { Breadcrumbs },
  props: {
    breadcrumbs: {
      type: [Array, null] as PropType<Breadcrumb[] | null>,
      default: () => ([]),
    },
    current: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const { collectBreadcrumbsJsonLd } = useStructuredData();

    const formattedBreadcrumbs = computed<BreadcrumbsInterface[]>(() => props.breadcrumbs.map((breadcrumb) => ({
      text: htmlDecode(breadcrumb.category_name),
      link: `/${breadcrumb.category_url_path}${PAGE_SUFFIX}`,
    })));

    const visibleItems = computed(() => ([...formattedBreadcrumbs.value, {
      text: props.current,
    }]));

    const jsonLd = computed(() => collectBreadcrumbsJsonLd(formattedBreadcrumbs.value, props.current));

    return {
      visibleItems,
      jsonLd,
    };
  },
});

